import axios from "axios";

class AkioService {
  static getConfiguration = (refererId) =>
    axios.get("/configuration", { params: { refererId } }).then((response) => {
      return response.data;
    });

  static getAvailability = (refererId, conditionUuids) =>
    axios.get("/availability", { params: { refererId, conditionUuids } }).then((response) => {
      return response.data;
    });

  static getCalendar = (refererId, conditionUuids) =>
    axios.post("/calendar", { refererId, conditionUuids }).then((response) => {
      return response.data;
    });

  static webcallback = (bodyParams) =>
    axios.post("/webcallback", bodyParams).then((response) => {
      return response.data;
    });
}

export default AkioService;
